// var fn_img_random = function () {

//     var imgList = [];
//     var imgContainer = $('.block-big-txt-img--img');
//     for (var i = 1; i < 6; i++) {
//         imgList.push(imgContainer.attr('data-random-img-' + i));
//     };

//     var id = Math.floor(Math.random() * 5);
//     if(localStorage.getItem("hpImgBufferId")!=undefined){
//         while (id == localStorage.getItem("hpImgBufferId")){
//             id = Math.floor(Math.random() * 5);
//         };
//     };

//     localStorage.setItem('hpImgBufferId', id);
//     imgContainer.children('img').attr('src', imgList[id]);

// }



function randomImages(imgContainer) {
    var imgList = [];
    // var div = imgContainer.count("data-random-img-");  // anciennement nbImg
    var temp = imgContainer.outerHTML;
    var nbImg = (temp.match(/data-random-img/g) || []).length;
    if (nbImg > 1) {

        var id = Math.floor(Math.random() * nbImg);
        
        for (var i = 0; i < nbImg; i++) {
            imgList.push(imgContainer.getAttribute('data-random-img-' + i));
        };
        
        //using local storage to prevent reloading the page multiple times with the same image
        if (localStorage.getItem("randomImgBufferId") != undefined) {
            while (id == localStorage.getItem("randomImgBufferId")) {
                id = Math.floor(Math.random() * nbImg);
            };
        };
        
        localStorage.setItem('randomImgBufferId', id);
        imgContainer.setAttribute('style', imgList[id]);
    }
    else {
        imgList.push(imgContainer.getAttribute('data-random-img-0'));
        imgContainer.setAttribute('style', imgList[0]);
    }
};

var imgContainer = document.getElementsByClassName('masthead-has-image')[0];
if (imgContainer) {
    randomImages(imgContainer);
}